var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "unstriped hover boss-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm.isExistJobs
          ? _vm._l(_vm.jobs, function (job, i) {
              return _c("job-pre-published-job", {
                key: i,
                attrs: {
                  job: job,
                  "is-show-options": _vm.isShowOptions(job.id),
                  "photoclip-ids": _vm.photoclipIds,
                  "interview-ids": _vm.interviewIds,
                  "options-rowspan": _vm.jobs.length,
                  "data-test": "job-pre-published-job-" + i,
                },
              })
            })
          : [
              _vm.isExistOptions
                ? [
                    _c(
                      "tr",
                      [
                        _c("td", { staticClass: "boss-table-data" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "boss-table-data" }),
                        _vm._v(" "),
                        _c("job-pre-published-option-sell", {
                          attrs: {
                            rowspan: 1,
                            "photoclip-ids": _vm.photoclipIds,
                            "interview-ids": _vm.interviewIds,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [_vm._m(1)],
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        求人ID\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        管理用求人名\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        求人名\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        掲載サイズ\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        求人プレビュー\n      "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "boss-table-head-center" }, [
          _vm._v("\n        オプション情報プレビュー\n      "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "6", "data-test": "jobs-no-data" } }, [
        _vm._v(
          "\n            ※掲載前確認中の求人やオプション情報はありません\n          "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }